import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { styled } from 'styled-components'
import { colors } from '../shared-constants/colors'
import { fontSize } from '../shared-constants/fonts'

const ContentLayout = ({ children, paddingTop = true, marginTop = true ,paddingInline=true}: any) => {
  return (
    <>
      {paddingTop ? (
        <ContentLayoutContainer paddingInline={paddingInline} className="content-layout" marginTop={marginTop}>{children}</ContentLayoutContainer>
      ) : (
        <ContentLayoutContainerInline paddingInline={paddingInline}>{children}</ContentLayoutContainerInline>
      )}
    </>
  )
}

export default ContentLayout

const ContentLayoutContainer = styled.div<any>`
  padding: ${(props) => props.paddingInline ? dimens.SPACING_M : 0}; 
  margin-top: ${(props) => props.marginTop ? dimens.PAGE_TITLE_HEIGHT : 0};
  .errorText {
    color: ${colors.RED};
    font-size: ${fontSize.SMALL};
  }
`

const ContentLayoutContainerInline = styled.div`
 padding: ${(props) => props.paddingInline ? dimens.SPACING_M : 0}; 
  padding-bottom: ${dimens.SPACING_M};
`
